export default __webpack_public_path__ + "static/media/favourite.bb9b4719.svg";